<template>
    <page-container style="flex-direction: column;">
        <pagination-table ref="pageTable" :tableList="tableList" showRefreshBtn showCloseBtn tablePermissionId="System.Log.List">
            <template v-slot:searchForm>
                <el-form-item label="操作行为">
                    <el-input v-model="tableList.searchForm.operation" placeholder="操作行为" clearable></el-input>
                </el-form-item>
            </template>
            <template v-slot:tableColumns>
               <el-table-column
                    prop="id"
                    label="ID"
                    width="100"
               >
               </el-table-column>
                <el-table-column
                    prop="username"
                    label="操作人"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="operation"
                    label="操作行为"
                    width="200">
                </el-table-column>
                <el-table-column
                    prop="ip"
                    label="IP"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="userAgent"
                    label="浏览器信息">
                </el-table-column>
                <el-table-column
                    prop="exeCostTime"
                    label="耗时（毫秒）"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="操作时间"
                    width="180">
                    <template slot-scope="scope">
                        <date-time-render :value="scope.row.createTime"/>
                    </template>
                </el-table-column>
            </template>
        </pagination-table>
    </page-container>
</template>

<script>
import List from "@/components/table/List";
export default {
    name: "SystemLogList",
    data()
    {
        return {
            tableList: new List({url: '/system/log/list'})
        }
    },
    created()
    {
        console.log('list created');
    },
    mounted()
    {
    },
    methods:
    {
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/system/pages/log/List.vue